import classNames from "classnames";

import { QuantityInput } from "@jti/core-components/components/QuantityInput";
import { truncateText } from "@jti/fe-common";
import { Tooltip } from "@jti/ui/components/Tooltip";
import { useTranslations } from "@jti/ui/providers/useTranslations";

const maxTooltipLength = 130;

// TODO: fix types / DESP-44757
export type ProductBundlesSingleStickType = {
  img: string;
  name: string;
  onChange: (data: any) => void;
  count: number;
  isInStock: boolean;
  isLoading: boolean;
  tooltip?: string;
  isLimitReached?: boolean;
};

const ProductBundlesSingleStick = ({
  img,
  name,
  onChange,
  count,
  isInStock,
  isLoading,
  tooltip,
  isLimitReached = false,
}: ProductBundlesSingleStickType) => {
  const { __ } = useTranslations();
  return (
    <div
      className={classNames("product-bundles-sticks__container", {
        "product-bundles-sticks__container--out-of-stock": !isInStock && !isLoading,
        "product-bundles-sticks__container--loading": isLoading,
      })}
      data-testid="product-bundles-single-stick"
      role="listitem"
    >
      <div className={"product-bundles-sticks__single-element"}>
        <div className={"product-bundles-sticks__single-element-side"}>
          <img src={img} alt={name} />
          <div className={"product-bundles-sticks__text-with-tooltip"}>
            <span className={"product-bundles-sticks__stick-name"}>{name}</span>
            {tooltip && (
              <Tooltip content={<span>{truncateText(tooltip, maxTooltipLength)}</span>} size="small" withCloseIcon />
            )}
          </div>
        </div>

        {isInStock && (
          <QuantityInput
            value={count}
            onChange={onChange}
            disabledAdd={isLimitReached}
            min={0}
            aria-label={__("productdetails.sticks.quantity.input", [name])}
            increaseButtonAriaLabel={__("productdetails.sticks.quantity.increase", [name])}
            decreaseButtonAriaLabel={__("productdetails.sticks.quantity.decrease", [name])}
          />
        )}
      </div>
    </div>
  );
};

export default ProductBundlesSingleStick;
